import {GroupBaseController} from './groupBase';

export class GroupResourcesController extends GroupBaseController {
    static $inject = ['$scope', '$rootScope', '$routeParams', '$q', '$window', '$http', 'VisitorService', '$analytics'];

    constructor($scope, $rootScope, $routeParams, $q, $window, $http, VisitorService, $analytics) {
        super($scope, $rootScope, $routeParams, $q, $window, $http, VisitorService, $analytics);
        $window.document.title = 'Booth Resources';
        $scope.position = 5;
    };
}
